import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useLenis } from "@/hooks/useLenis";
import { BookingProvider, useBooking } from "@/context/BookingContext";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Problem } from "@/components/landing/Problem";
import { Comparison } from "@/components/landing/Comparison";
import { Itinerary } from "@/components/landing/Itinerary";
import { Qualification } from "@/components/landing/Qualification";
import { Packaging } from "@/components/landing/Packaging";
import { Faqs } from "@/components/landing/Faqs";
import { FooterCta } from "@/components/landing/FooterCta";
import { ConsultationModal } from "@/components/landing/ConsultationModal";

const Nav = () => {
  const { openBooking } = useBooking();
  const [solid, setSolid] = useState(false);
  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <motion.nav
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.3 }}
      className={`fixed inset-x-0 top-0 z-50 flex items-center justify-between px-7 py-4 transition-colors duration-300 sm:px-12 lg:px-20 ${solid ? "border-b border-white/10 bg-ink/85 backdrop-blur-md" : "bg-transparent"}`}
      data-testid="navbar"
    >
      <a href="/" data-testid="nav-logo" className="flex items-center">
        <img src="/master-logo.png" alt="NORTHEASTGO" className="h-12 w-auto sm:h-14 lg:h-16" />
      </a>
      <Button
        data-testid="nav-book-btn"
        onClick={() => openBooking()}
        className="h-10 rounded-none bg-gold px-5 text-xs font-bold uppercase tracking-[0.1em] text-ink hover:bg-gold-hover"
      >
        Plan My Trip
      </Button>
    </motion.nav>
  );
};

const Landing = () => {
  useLenis();
  return (
    <BookingProvider>
      <div className="App bg-paper" data-testid="landing-page">
        <Nav />
        <Hero />
        <Marquee />
        <Problem />
        <Comparison />
        <Itinerary />
        <Qualification />
        <Packaging />
        <Faqs />
        <FooterCta />
        <ConsultationModal />
      </div>
    </BookingProvider>
  );
};

export default Landing;
